export enum FilterType {
    Locations = 1,
    Serials = 2,
    Percentage = 3,
    DevicesPerLocation = 4,
    LocationData = 5,
    LastSeen = 7,
    MenuVersion = 8,
    FirmwareVersion = 9,
    ThingIDs = 10,
};
